<div class="app-modal-title">Rename</div>
<div class="app-modal-content">
	<div class="">
		<input name="agency-name" [(ngModel)]="shortName" style="width: 100%;">
	</div>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" md-raised-button (click)="cancel()">Cancel</button>
		<button class="button-general" md-raised-button (click)="save()" [disabled]="!shortName">Save</button>
	</div>
</div>
